<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-11 15:10:33
-->
<template>
  <div class="container">
    <section class="heder">
      <div class="title"><span></span>惠企政策</div>
    </section>
    <section class="body">
      <div v-if="custom">
        <el-button @click="show = true" v-if="!show">编 辑</el-button>
        <el-button @click="cancel" v-if="show">取 消</el-button>
        <el-button type="primary" @click="updateFillData" v-if="show"
          >保 存</el-button
        >
      </div>
      <div v-if="custom">
        <table border="1" cellspacing="0" cellpadding="10">
          <tbody>
            <tr v-for="item in list1" :key="item.targetName">
              <td>{{ item.targetName }}</td>
              <td>
                <el-input v-model="item.targetValue" v-if="show"></el-input>
                <div
                  v-else
                  style="height:32px;width:202px;line-height: 32px;text-align: center"
                >
                  {{ item.targetValue }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { updateEntPolicy } from '@api/dataMaintenance/dataMaintenance'
export default {
  props: {
    entPolicies: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    newList() {
      return JSON.parse(JSON.stringify(this.entPolicies))
    }
  },
  watch: {
    newList(newVal, oldVal) {
      this.list1 = JSON.parse(JSON.stringify(newVal))
      if (!this.list) {
        this.list = JSON.parse(JSON.stringify(newVal))
      }
    }
  },
  data() {
    return {
      custom: true,
      show: false,
      tableList: [
        { targetName: '今年兑现金额（万元）', targetValue: 4 },
        { targetName: '与公共预算收入比（%）', targetValue: 4 },
        { targetName: '事项数（个）', targetValue: 4 },
        { targetName: '惠企数（家）', targetValue: 4 }
      ],
      list: null,
      list1: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    cancel() {
      this.show = false
      this.list1 = JSON.parse(JSON.stringify(this.list))
    },
    updateFillData() {
      updateEntPolicy({ list: this.list1 }).then(res => {
        if (res.data.code == '0000') {
          this.$message.success(res.data.msg)
          this.show = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 12px 0;
  background: #fff;
  .heder {
    margin-bottom: 15px;
    > .title {
      display: flex;
      align-items: center;
      line-height: 20px;
      > span {
        display: inline-block;
        width: 4px;
        height: 20px;
        background: #46a6ff;
        border-radius: 3px;
        margin-right: 6px;
      }
    }
  }
  .body {
    table {
      border-color: #e8e8e8;
    }
    > div {
      margin-bottom: 20px;
    }
    /deep/ .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
